import * as _ from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { profileBusinessService } from "../../services/profile-business.service";

export const listProfileBusinessHourByProfileId = createAsyncThunk(
  "profileBusinessManage/listProfileBusinessHourByProfileId",
  async (profileId, { rejectWithValue }) => {
    try {
      const response =
        await profileBusinessService.listProfileBusinessHourByProfileId(
          profileId
        );

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const listProfileSpecialDayByProfileId = createAsyncThunk(
  "profileBusinessManage/listProfileSpecialDayByProfileId",
  async (profileId, { rejectWithValue }) => {
    try {
      const response =
        await profileBusinessService.listProfileSpecialDayByProfileId(
          profileId
        );

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addProfileBusiness = createAsyncThunk(
  "profileBusinessManage/addProfileBusiness",
  async (data, { rejectWithValue }) => {
    try {
      const response = await profileBusinessService.addProfileBusiness(data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editProfileBusiness = createAsyncThunk(
  "profileBusinessManage/editProfileBusiness",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await profileBusinessService.editProfileBusiness(
        id,
        data
      );

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const removeProfileBusiness = createAsyncThunk(
  "profileBusinessManage/removeProfileBusiness",
  async (id, { rejectWithValue }) => {
    try {
      const response = await profileBusinessService.removeProfileBusiness(id);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
